import { object, string } from 'yup'

export const companyDetailsSchema = object({
    company: string()
        .when('isIndependent', { is: false, then: string().required('Required')})
        .min(8, 'At least 8 charachters'),
    address: string().required('Required'),
    // country: string().required('Required'),
    // state: string().required('Required'),
    // city: string().required('Required'),
    zip_code: string().required('Required'),
});

export const paymentDetailsSchema = object({
    cardName: string()
        .required('Required')
        .min(8, 'At least 8 charachters'),
    cardNumber: string().required('Required'),
    cvv: string().required('Required'),
    expiryMonth: string().required('Required'),
    expiryYear: string().required('Required')
});

export const emptySchema = object({})